import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ToolTip from '../../ui/ToolTip';
import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';
import { ResetPasswordTokenSchema } from '../validation';
import FloatingLabel from 'floating-label-react';

class TokenPasswordResetForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { token, onSubmit, onBack } = this.props;
    let initialValues = {
      token: token,
      newPassword: '',
      newPasswordConfirm: ''
    }
    let toolTipMessage = "Passwords must meet the following requirements:\n" +
      "\t8 character minimum\n\t1 lower case letter\n\t1 upper case minimum\n" +
      "\t1 numeric character\n\t1 special character";

    return (
      <div className="main-container">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">Set New Password</h1>
                <p className="detail-text">Please set a secure password for your account.</p>
                <Formik
                  validationSchema={ResetPasswordTokenSchema}
                  initialValues={initialValues}
                  onSubmit={onSubmit}>
                  {formProps => (
                    <Form>
                      <div className="signin-page">
                        <div className="form-section">
                          <div>
                            <div className="form-group">
                              <FloatingLabel
                                name="newPassword"
                                type="password"
                                placeholder="New Password"
                                id="password"
                                className="form-control password-control"
                                value={formProps.values.newPassword}
                                onChange={formProps.handleChange}
                              />
                              <ToolTip className="forget-tooltip-main" position="right" message={toolTipMessage}><i className="far fa-question-circle"></i></ToolTip>
                              <ErrorMessage name='newPassword' render={msg => <div className="invalid-feedback">{msg}</div>} />
                            </div>
                            <div className="form-group">
                              <FloatingLabel
                                name="newPasswordConfirm"
                                type="password"
                                placeholder="Confirm New Password"
                                id="password"
                                className="form-control password-control"
                                value={formProps.values.newPasswordConfirm}
                                onChange={formProps.handleChange}
                              />
                              <ErrorMessage name='newPasswordConfirm' render={msg => <div className="invalid-feedback">{msg}</div>} />
                            </div>
                          </div>
                          <div className="combo-button">
                            <div className="back-button">
                              <button type="button" className="btn dark" onClick={onBack}>Back</button>
                            </div>
                            <div className="signin-button">
                              <button type="submit" className="btn primary">Set Password</button>
                            </div>
                          </div>
                          {/* <div className="no-account-detail">
                            <p className="account-text">Back to <Link to={PAGE_ROUTES.LOGIN} className="signup-link">Sign In</Link></p>
                          </div> */}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>

              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default TokenPasswordResetForm;
